<app-modal-component [open]="openModal" labelledBy="ts-eyebrow ts-title" (dismiss)="close()">
  <div class="set-modal ts">
    <!-- One live region for the whole dialog, so the result is announced reliably -->
    <p class="bk-sr-only" role="status" aria-live="polite">{{ announcement }}</p>

    <header class="set-modal__head">
      <div class="set-modal__intro">
        <p class="bk-eyebrow" id="ts-eyebrow">Send test SMS</p>
        <h2 class="set-modal__title" id="ts-title">{{ name }}</h2>
        <p class="set-modal__sub">{{ phone || 'No phone number on record' }}</p>
      </div>
      <button type="button" class="bk-icon-btn" aria-label="Close" (click)="close()" [disabled]="sending">
        <span class="bk-sym" aria-hidden="true">close</span>
      </button>
    </header>

    <!-- 1. Write the message -->
    @if (step === 'compose') {
      <div class="set-modal__body">
        @if (sendError) {
          <p class="set-alert" role="alert">
            <span class="bk-sym" aria-hidden="true">error</span>
            <span>{{ sendError }}</span>
          </p>
        }

        <input-field label="Sender ID" [errorMessage]="senderError" hint="What the phone shows as the sender.">
          @if (sendersLoading) {
            <span class="ts__loading">Loading sender IDs…</span>
          } @else if (sendersFailed) {
            <span class="ts__loading">
              The sender IDs did not load.
              <button type="button" class="bk-more" (click)="retrySenders()">Try again</button>
            </span>
          } @else if (!senderIds.length) {
            <span class="ts__loading">Your organization has no sender IDs yet. Contact Black Konnect support.</span>
          } @else {
            <select class="input-style" name="senderId" [(ngModel)]="senderId">
              @for (id of senderIds; track id) {
                <option [value]="id">{{ id }}</option>
              }
            </select>
          }
        </input-field>

        <input-field label="Message" [errorMessage]="messageError">
          <textarea
            #messageInput
            class="input-style ts__text"
            name="message"
            rows="4"
            placeholder="The exact copy you plan to send"
            [(ngModel)]="message"
          ></textarea>
        </input-field>

        <div class="ts__preview" role="group" aria-label="How the message looks on a phone">
          <bk-sms-bubble
            [text]="message"
            variant="compact"
            [clamp]="0"
            [exact]="true"
            emptyText="Start typing to see the message as the phone shows it."
          />
        </div>
      </div>

      <footer class="set-modal__foot">
        <button type="button" class="bk-btn bk-btn--ghost" (click)="close()">Cancel</button>
        <button
          type="button"
          class="bk-btn bk-btn--primary"
          (click)="review()"
          [disabled]="sendersLoading || !senderIds.length"
        >
          Review test
        </button>
      </footer>
    }

    <!-- 2. Confirm: it is a real SMS -->
    @if (step === 'confirm') {
      <div
        #confirmBody
        class="set-modal__body ts__step"
        role="group"
        aria-label="Check the test before it is sent"
        tabindex="-1"
      >
        <dl class="bk-kv ts__facts">
          <dt>To</dt>
          <dd>{{ name }}, {{ phone }}</dd>
          <dt>From</dt>
          <dd>{{ senderId }}</dd>
          <dt>Length</dt>
          <dd>{{ partsLabel }}</dd>
        </dl>

        <bk-sms-bubble [text]="message" variant="compact" [clamp]="6" [exact]="true" />

        <p class="set-note">
          <span class="bk-sym" aria-hidden="true">sms</span>
          <span>This sends <strong>one real SMS</strong> to this phone now. It cannot be called back.</span>
        </p>

        @if (sendError) {
          <p class="set-alert" role="alert">
            <span class="bk-sym" aria-hidden="true">error</span>
            <span>{{ sendError }}</span>
          </p>
        }
      </div>

      <footer class="set-modal__foot">
        <button type="button" class="bk-btn bk-btn--ghost" (click)="back()" [disabled]="sending">Back</button>
        <customizable-button
          title="Send test now"
          leftIcon="send"
          className="w-full"
          [loading]="sending"
          [disabled]="sending"
          (click)="send()"
        />
      </footer>
    }

    <!-- 3. What the gateway said -->
    @if (step === 'result' && result) {
      <div class="set-modal__body">
        <div class="ts__result">
          <app-status [text]="result.statusText" [status]="result.status" />
          <p class="ts__detail">{{ result.detail }}</p>
          @if (result.reference) {
            <p class="ts__ref">Reference {{ result.reference }}</p>
          }
        </div>
        <p class="set-modal__sub">
          Nothing arrived after a few minutes? Check the number, then try a different sender ID.
        </p>
      </div>

      <footer class="set-modal__foot">
        <button type="button" class="bk-btn bk-btn--ghost" (click)="sendAnother()">Edit and send again</button>
        <button #doneButton type="button" class="bk-btn bk-btn--primary" (click)="close()">Done</button>
      </footer>
    }
  </div>
</app-modal-component>
